import { getGlobalSituation } from "./get"
import { milestones } from "./milestones"

export const courses = {
  getGlobalSituation,
  milestones,
}
